module.exports = __webpack_public_path__ + "img/ods.ab6d1e53.svg";